module.exports = __webpack_public_path__ + "static/media/toll_modal.ee01d8fa.svg";